import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sydney-distributor/artifacts/l39oq0om_Untitled%20%28Your%20Story%29%20%281600%20x%20680%20px%29.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#01195d] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="GS Pacific"
              className="h-14 md:h-16 w-auto mb-6"
            />
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Your trusted Australian wholesale distributor. Supplying quality grocery and FMCG products to businesses across New South Wales.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="text-slate-300 hover:text-white transition-colors text-sm"
                >
                  Why GS Pacific
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-slate-300 hover:text-white transition-colors text-sm"
                >
                  Our Products
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('who-we-serve')}
                  className="text-slate-300 hover:text-white transition-colors text-sm"
                >
                  Who We Serve
                </button>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-slate-300 hover:text-white transition-colors text-sm"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms-link"
                  className="text-slate-300 hover:text-white transition-colors text-sm"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-slate-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm">
                  Unit 1, 2 Costello Place<br />
                  Seven Hills NSW 2147
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-slate-400 flex-shrink-0" />
                <a
                  href="tel:1800934114"
                  className="text-slate-300 hover:text-white transition-colors text-sm"
                >
                  1800 934 114
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-slate-400 flex-shrink-0" />
                <a
                  href="mailto:info@gspacific.com.au"
                  className="text-slate-300 hover:text-white transition-colors text-sm"
                >
                  info@gspacific.com.au
                </a>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Business Hours</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Clock className="w-5 h-5 text-slate-400 flex-shrink-0" />
                <div className="text-slate-300 text-sm">
                  <p>Monday - Friday</p>
                  <p className="text-white font-medium">8:00 AM - 4:00 PM</p>
                </div>
              </li>
              <li className="text-slate-400 text-sm mt-4">
                Closed on Weekends & Public Holidays
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {currentYear} GS Pacific Marketing. All rights reserved.
          </p>
          <p className="text-slate-400 text-sm">
            ABN: 51 114 918 366
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
